export enum PromoCodeTypes {
    percent = 'percent',
    value = 'value',
    freeDelivery = 'freeDelivery',
  };